import { Box, Typography } from "@mui/material";

type Props = {
  points: string;
};

export const Points = ({ points }: Props) => (
  <Box textAlign="center">
    <Typography
      variant="body2"
      color="text.secondary"
      fontSize="0.875rem"
      fontWeight={500}
    >
      {points}
    </Typography>
  </Box>
);
